<script>
import TwCard from '@/components/generic/tw-card.vue'
import FundraiserPageSlideShow from '@/components/fundraiser-pages/public/fundraiser-page-slide-show.vue'
import DonationsListGroup from '@/components/donations/public/donations-list-group.vue'
import FundraiserPageTabs from './fundraiser-page-tabs.vue'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'

export default {
  name: 'FundraiserPageLeftColumn',
  components: { FundraiserPageTabs, DonationsListGroup, FundraiserPageSlideShow, TwCard },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  },
  computed: {
    fundraiser() {
      return useFundraiserPublicStore().getItemById(this.fundraiserPage.fundraiser_id)
    }
  }
}
</script>

<template>
  <div>
    <div class="flex gap-5 mt-4 md:mt-8 items-center">
      <tw-card size="sm" class="w-full bg-gray-100 text-base shadow-none flex gap-5 items-center">
        <div class="lg:flex hidden">
          <img v-if="fundraiserPage.cached.owner_avatar_url_small" class="inline-block min-w-20 h-20 w-20 rounded-full object-cover" :src="fundraiserPage.cached.owner_avatar_url_small" :alt="fundraiserPage.cached.owner_name">
          <span v-else class="inline-flex h-20 w-20 items-center justify-center rounded-full bg-gray-200">
            <span v-if="fundraiserPage.cached.owner_initials" class="text-2xl leading-none text-gray-400">{{ fundraiserPage.cached.owner_initials }} </span>
          </span>
        </div>
        <div>
          <h5>
            <span v-if="fundraiser && fundraiser.settings && fundraiser.settings.lock_title"> {{ fundraiserPage.cached.owner_name }} is raising </span><span v-else>Raising</span> funds for <router-link v-if="fundraiser" class="underline" :to="{name: 'FundraiserPublicPage', params: { fundraiserId: fundraiserPage.fundraiser_id, slug: fundraiser.slug }}">
              {{ fundraiserPage.cached.fundraiser_title }}
            </router-link>.
          </h5>
          <p class="mt-1 text-sm">
            All donations go to <span>{{ fundraiserPage.cached.beneficiary_name }}</span>
          </p>
        </div>
      </tw-card>
    </div>
    <fundraiser-page-slide-show v-if="fundraiserPage" show-navigation :fundraiser-page="fundraiserPage" />
    <fundraiser-page-tabs :fundraiser-page="fundraiserPage" :fundraiser="fundraiser" class="my-10" />
    <div v-if="fundraiser && fundraiser.settings && fundraiser.settings.disclaimer" class="mt-10" v-html="fundraiser.settings.disclaimer" />
    <donations-list-group class="lg:hidden" :fundraiser-page="fundraiserPage" />
  </div>
</template>

<style scoped>

</style>
